import { yupResolver } from "@hookform/resolvers/yup";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import logo from "../../image/Banner.png";
import CustomTextField from "../../components/customFields/CustomTextField";
import { Paper } from "@mui/material";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";

const validacionSchema = yup.object().shape({
  nombre: yup.string().required("El nombre es requerido"),
  apellido: yup.string().required("El apellido es requerido"),
  mail: yup
    .string()
    .email("El correo electrónico no es válido")
    .required("El correo electrónico es requerido"),
});

const FormularioContacto = () => {
  const [loading, setLoading] = useState(false);

  const methods = useForm({
    shouldUnregister: false,
    defaultValues: {
      nombre: "",
      apellido: "",
      puesto: "",
      mail: "",
      telefono: "",
      empresa: "",
      productoInteres: "FinteChile 2025",
      contactoDesde: "",
      comentarios: "",
      referidoDesde: "",
    },
    resolver: yupResolver(validacionSchema),
    mode: "onChange",
  });

  const { handleSubmit, reset } = methods;

  const sendEmail = async (data) => {
    setLoading(true);
    try {
      await emailjs.send(
        "service_984etwg",
        "template_73cfo1o",
        {
          nombre: data.nombre,
          apellido: data.apellido,
          puesto: data.puesto,
          email: data.mail,
          celular: data.telefono,
          empresa: data.empresa,
          productoInteres: data.productoInteres,
          contactoDesde: data.contactoDesde,
          comentarios: data.comentarios,
          referidoDesde: data.referidoDesde,
        },
        "TGSn7vdlR5KS6e7K4"
      );

      toast.success("Formulario enviado con éxito!", {
        theme: "dark",
        position: "top-center",
        autoClose: 2000,
      });

      reset();
    } catch (error) {
      toast.error("Error al enviar el formulario. Inténtalo de nuevo.", {
        theme: "dark",
        position: "top-center",
        autoClose: 2000,
      });
      console.error("EmailJS error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      component="main"
      maxWidth="md"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Box display="flex" flexDirection="column" alignItems="center">
        <Grid
          container
          sx={{
            width: "100%",
            mt: { xs: "1rem" },
          }}
        >
          <Grid item xs={12}>
            <Box
              component="img"
              src={logo}
              alt="Logo de la empresa"
              sx={{
                width: "100%",
              }}
            />
          </Grid>
        </Grid>

        <Paper
          elevation={3}
          sx={{
            p: 2,
            mb: 2,
            borderBottomLeftRadius: 5,
            borderBottomRightRadius: 5,
          }}
        >
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(sendEmail)}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} >
                  <CustomTextField
                    req={true}
                    type="text"
                    label="Nombre"
                    name="nombre"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomTextField 
                    req={true}
                    type="text"
                    label="Apellidos"
                    name="apellido"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomTextField
                    req={true}
                    type="email"
                    label="Mail"
                    name="mail"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomTextField
                    type="text"
                    label="Teléfono"
                    name="telefono"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomTextField type="text" label="Empresa" name="empresa" />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomTextField type="text" label="Puesto" name="puesto" />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomTextField
                    type="text"
                    label="Producto de Interés"
                    name="productoInteres"
                    readOnly
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomTextField
                    type="text"
                    label="Referido desde"
                    name="referidoDesde"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <CustomTextField
                    type="text"
                    label="Contacto desde"
                    name="contactoDesde"
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomTextField
                    type="text"
                    label="Comentarios"
                    name="comentarios"
                    multiline
                    rows={6}
                  />
                </Grid>
              </Grid>

              <Box
                sx={{ mt: 3, mb: 2, position: "relative", textAlign: "center" }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  disabled={loading}
                  sx={{ backgroundColor: "#1786A0", color: "#fff" }}
                >
                  Enviar
                  {loading && (
                    <CircularProgress
                      size={27}
                      sx={{
                        color: "#fff",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        marginTop: "-12px",
                        marginLeft: "-12px",
                      }}
                    />
                  )}
                </Button>
              </Box>
            </form>
          </FormProvider>
        </Paper>
      </Box>
    </Container>
  );
};

export default FormularioContacto;
